<template>
  <div class="cloudAdapter">
    <div v-if="project.length !== 0 && !loading">
      <a-card :bordered="false" v-for="(v, j) in project" :key="j" style="margin-bottom: 10px;">
        <div slot="title" class="project-header">
          <span class="name" :title="v.name">
            {{ v.name }}
          </span>
          <span class="status">
            <a-badge :color="v.statusColor" :text="v.statusName" />
          </span>
          <span v-if="
            !(
              v.statusName == '待审核' ||
              v.statusName == '未通过'
            )
          " class="time">
            <span>(</span>
            <span class="use-days">{{ v.useDays }}</span>
            <span>/</span>
            <span class="sum-days">{{ v.sumDays }}</span>
            <span>天)</span>
          </span>
        </div>

        <a-popover overlayClassName="popover-layout" placement="bottomRight" slot="extra">
          <template slot="content">
            <p class="apply-info">
              <span class="title">{{ columns.applyTime }}</span>
              <span class="desc">{{ v.startTime }}</span>
            </p>
            <p class="apply-info">
              <span class="title">{{ columns.name }}</span>
              <span class="desc" :title="v.name">{{ v.name }}</span>
            </p>
            <p class="apply-info">
              <span class="title">{{ columns.company }}</span>
              <span class="desc">{{ v.adapterApply.company }}</span>
            </p>
            <p class="apply-info">
              <span class="title">{{ columns.applier }}</span>
              <span class="desc">{{ v.adapterApply.applier }}</span>
            </p>
            <p class="apply-info">
              <span class="title">{{ columns.phone }}</span>
              <span class="desc">{{ v.adapterApply.phone }}</span>
            </p>
            <p class="apply-info">
              <span class="title">{{ columns.email }}</span>
              <span class="desc">{{ v.adapterApply.email }}</span>
            </p>
          </template>
          <a>申请信息</a>
        </a-popover>

        <div class="project-content">
          <div v-if="
            v.type === 'dm8' ||
            v.type === 'dm8+linux' ||
            v.type === 'dm8+windows'
          " class="database-type">
            <div class="case-contain">
              <div class="rect">
                <eco-icon class="icon" name="dm" :size="40" />
                <span class="database">DM8</span>
              </div>
              <eco-icon v-if="v.type == 'dm8+linux' || v.type == 'dm8+windows'" name="addto" size="16"
                style="margin: 0 6px;" />
              <div v-if="v.type === 'dm8+linux'" class="case-linux">
                <div class="rect">
                  <eco-icon class="icon" name="linux" :size="40" />
                  <span class="database">Linux</span>
                </div>
              </div>
              <div v-if="v.type === 'dm8+windows'" class="case-windows">
                <div class="rect">
                  <eco-icon class="icon" name="windows" :size="40" />
                  <span class="database">Windows</span>
                </div>
              </div>
            </div>
          </div>

          <div v-if="
            v.type === 'dm8' ||
            v.type === 'dm8+linux' ||
            v.type === 'dm8+windows'
          " class="project-database-info">
            <div v-if="v.type === 'dm8'" class="case-dm8">
              <div class="list">
                <div class="item">
                  <p class="title">数据库版本</p>
                  <p class="desc">{{ v.dataBase.version }}</p>
                </div>
                <div class="item">
                  <p class="title">数据库架构</p>
                  <p class="desc">{{ v.dataBase.frameWork }}</p>
                </div>
              </div>
            </div>

            <div v-if="v.type === 'dm8+linux' || v.type === 'dm8+windows'" class="dm8-linux">
              <p class="comp-title">
                云服务配置
              </p>
              <div class="list">
                <div class="item">
                  <p class="title">CPU</p>
                  <p class="desc">{{ v.service.cpu }}</p>
                </div>
                <div class="item">
                  <p class="title">OS</p>
                  <p class="desc" style="
                      max-width: 200px;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                    " :title="v.service.os">
                    {{ v.service.os }}
                  </p>
                </div>
                <div class="item">
                  <p class="title">内存</p>
                  <p class="desc">{{ v.service.memory }}</p>
                </div>
                <div class="item">
                  <p class="title">云硬盘</p>
                  <p class="desc">{{ v.service.hardDisk }}</p>
                </div>
                <div class="item">
                  <p class="title">网络</p>
                  <p class="desc">{{ v.service.network }}</p>
                </div>
                <div class="item">
                  <p class="title">数据库版本</p>
                  <p class="desc">{{ v.dataBase.version }}</p>
                </div>
                <div class="item">
                  <p class="title">数据库架构</p>
                  <p class="desc">{{ v.dataBase.frameWork }}</p>
                </div>
              </div>
            </div>
          </div>

          <div v-if="v.type == 'efficiency'" class="case-efficiency">
            <p class="title">性能适配</p>
            <p v-if="v.statusName === '待审核'" class="desc">
              <eco-icon name="Tips" :size="16" style="margin-right: 4px;"></eco-icon>
              申请通过后，技术工程师将为您提供全套国产化软硬件环境，您可根据应用需求选择数据库集群架构进行性能调优。
            </p>
            <p v-else class="desc">
              达梦提供全套国产化软硬件环境，您可根据应用需求选择数据库集群架构进行性能调优。
            </p>
            <p v-if="v.statusName === '未通过'" class="desc" style="margin-top: 16px;">
              <eco-icon name="earlywarning1" :size="16" style="margin-right: 4px;"></eco-icon>
              <span>审核不通过原因：</span>
              <span style="display: block; padding: 14px 0 0 21px;">
                {{ v.reason }}
              </span>
            </p>
          </div>

          <div v-else-if="v.type == 'authenticate'" class="case-auth" style="padding:">
            <p class="title">获取兼容认证</p>
            <p v-if="v.statusName === '待审核'" class="desc">
              <eco-icon name="Tips" :size="16" style="margin-right: 4px;"></eco-icon>
              申请通过后客服人员将联系您填写功能测试报告，制作证书。
            </p>
            <p v-else-if="v.statusName === '未通过'" class="desc">
              <eco-icon name="earlywarning1" :size="16" style="margin-right: 4px;"></eco-icon>
              <span>审核不通过原因：</span>
              <span style="display: block; padding: 14px 0 0 21px;">
                {{ v.reason }}
              </span>
            </p>
            <!-- v.statusName === '已结束' || v.statusName === '已完成' ||  -->
            <p v-else-if="v.statusName === '已完成' || v.statusName === '已结束'" class="desc">
              <eco-icon name="Tips" :size="16" style="margin-right: 4px;"></eco-icon>
              已填写功能测试报告，证书制作已完成。
            </p>
            <!-- v.statusName === '适配中' || '已暂停' -->
            <p v-else class="desc">
              <eco-icon name="Tips" :size="16" style="margin-right: 4px;"></eco-icon>
              适配完成并填写测试报告后，您可获取兼容认证证书。
            </p>
          </div>

          <div v-else class="project-cloud-info" :style="v.statusName === '已完成' ? 'padding:10px 0 18px' : ''">
            <div class="list1">
              <p class="name comp-title">云服务信息</p>
              <div v-if="v.statusName !== '待审核'" class="feed-info">
                <div v-for="(x, m) in v.allocate" :key="m" class="item-wrapper" :style="{
                  paddingBottom: '12px',
                  borderBottom:
                    m !== v.allocate.length - 1
                      ? '1px dotted rgba(0, 0, 0, 0.1)'
                      : 'none',
                }">
                  <div class="item">
                    <div class="row">
                      <span class="title">{{ cloudSource.serviceIp }}</span>
                      <span class="desc">{{ x.cloudIp }}</span>
                    </div>
                    <div class="row">
                      <span class="title">{{ cloudSource.port }}</span>
                      <span class="desc">{{ x.port }}</span>
                    </div>
                  </div>
                  <div class="item">
                    <div class="row">
                      <span class="title">{{ cloudSource.userName }}</span>
                      <span class="desc">{{ x.account }}</span>
                    </div>
                    <div class="row">
                      <!-- 云主机密码 -->
                      <span class="title">{{ cloudSource.password }}</span>
                      <template v-if="!x.showPassword">
                        <span class="desc">{{ x.hashPassword }}</span>
                      </template>
                      <template v-else>
                        <span class="desc">{{ x.password }}</span>
                      </template>
                      <a style="margin-left: 12px;" @click="x.showPassword = !x.showPassword">
                        <eco-icon v-show="!x.showPassword" :size="14" name="closeeyes"></eco-icon>
                        <eco-icon v-show="x.showPassword" :size="14" name="see"></eco-icon>
                      </a>
                    </div>
                  </div>
                  <div class="item">
                    <div class="row">
                      <span class="title">{{ cloudSource.admin }}</span>
                      <span class="desc">{{ x.saAccount }}</span>
                    </div>
                    <div class="row">
                      <span class="title">{{ cloudSource.dataBasePwd }}</span>

                      <!-- 超级管理员密码 -->
                      <template v-if="!x.showSaPwd">
                        <span class="desc">{{ x.hashSaPwd }}</span>
                      </template>
                      <template v-else>
                        <span class="desc">{{ x.saPwd }}</span>
                      </template>
                      <a style="margin-left: 12px;" @click="x.showSaPwd = !x.showSaPwd">
                        <eco-icon v-show="!x.showSaPwd" :size="14" name="closeeyes"></eco-icon>
                        <eco-icon v-show="x.showSaPwd" :size="14" name="see"></eco-icon>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <p v-if="v.statusName == '待审核'" class="desc">
                  <eco-icon name="Tips" :size="16" style="margin-right: 4px;"></eco-icon>
                  审核通过后技术工程师会为您分配资源，请耐心等待！
                </p>
                <p v-if="v.statusName == '未通过'" class="desc">
                  <eco-icon name="Tips" :size="16" style="margin-right: 4px;"></eco-icon>
                  <span>审核不通过原因：</span>
                  <span style="display: block; padding: 14px 0 0 21px;">
                    {{ v.reason }}
                  </span>
                </p>
              </div>
            </div>
          </div>

          <!--  ||
              v.type === 'authenticate' -->
          <div v-show="v.statusName === '待审核' ||
            v.statusName === '未通过' ||
            v.type === 'authenticate'
            " class="list2" :style="{
              top:
                v.type === 'authenticate' || v.type === 'efficiency'
                  ? '0'
                  : v.type === 'dm8' ? '148px' : '187px',
            }">
            <div style="text-align: center;">
              <img src="../../assets/ercode/WXWork-logo.png" />
              <p class="serve">更多服务请咨询客服</p>
            </div>
          </div>

          <!-- 评价 -->
          <div v-if="v.statusName === '已完成'" class="project-appraise">
            <div class="service">
              <p class="title">服务态度</p>
              <a-rate v-model="v.rate" :disabled="v.isEvaluate === '1'" />
            </div>
            <div class="rate-content">
              <p class="title">建议与反馈</p>
              <template v-if="v.isEvaluate === '0'">
                <a-form-model :ref="v.projectId" :rules="rules" :model="v">
                  <a-form-model-item class="form-item" :colon="false" prop="rateContent">
                    <a-input class="content" v-model="v.rateContent" placeholder="请您对本次适配过程做出评价，期待您的改进建议"
                      type="textarea" />
                  </a-form-model-item>
                </a-form-model>
              </template>
              <p class="content" v-if="v.isEvaluate === '1'">{{ v.rateContent }}</p>
            </div>
            <div class="btn" v-if="v.isEvaluate === '0'">
              <a-button type="primary" @click="handleRate(v)">提交评价</a-button>
            </div>
          </div>
        </div>
      </a-card>
    </div>
    <a-spin v-if="loading" style="position: absolute;left: 50%;top: 50%;transform: translate(-50%, -50%);"
      size="large" />
    <div v-if="!loading && (project.length == 0 || !project)" class="cloud-intro">
      <div class="welcome-title">欢迎使用达梦云适配服务</div>
      <div class="welconme-desc">
        <p class="item1" style="width:732px">
          达梦云适配服务提供“开箱即用”的云端 DM8
          数据库环境，应用厂商无需在本地部署
          DM8数据库，直接连接云环境，即可开展应用程序的功能适配，显著降低了适配的技术难度和成本。全程提供达梦技术专家一对一的疑难诊断和联合调试，最大程度地帮助应用厂商顺利的完成适配工作。
        </p>
        <p class="item1" style="margin-top:40px">
          云适配环境申请流程
        </p>

        <div class="steps" style="margin-top:12px">
          <div class="step">
            <div class="header">申请账号</div>
            <div class="body">填写企业和联系人信息，<br>以便项目过程中我们为您提供技术专员服务。</div>
          </div>
          <div class="next"><eco-icon name="arrow-right" :size="24"></eco-icon></div>
          <div class="step">
            <div class="header">选择云服务器配置</div>
            <div class="body">根据您的项目规模选择云服务器环境配置和达梦数据库版本。</div>
          </div>
          <div class="next"><eco-icon name="arrow-right" :size="24"></eco-icon></div>
          <div class="step" style="width:362px">
            <div class="header">管理员分配资源</div>
            <div class="body">管理员收到您的申请后，为您分配相关资源并进行初始化工作。您可以登录控制台查看申请进度。资源分配成功后，您即可开启云适配工作。<br><br>下载 <a class="title "
                href="https://www.sqlark.com/" target="_blank">信创数据库开发和管理工具 SQLark</a> 进行适配。</div>
          </div>
        </div>
      </div>
      <a-button type="primary" class="btns" @click="toApply">立即申请</a-button>

    </div>

    <div v-else>

      <div class="sqlark-div"></div>
      <div class="project-cloud-info sqlark">
        <div class="list1">
          <p class="name comp-title">下载 信创数据库开发和管理工具 SQLark ，开启适配工作。</p>
        </div>

        <div class="sqlark-info">
          <div class="sqlark-logo" :style="{ backgroundImage: `url(${require('@/assets/SQLark-app.svg')})` }"></div>
          <div class="content">
            <div class="name">SQLark</div>
            <div class="desc">百灵连接 — 面向信创应用开发者的数据库开发和管理工具</div>
          </div>
          <a class="download-btn" href="https://www.sqlark.com" target="_blank">
            前往官网下载
          </a>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {
  getProjectOfCurrentUser,
  addRate
} from '@/request/adapter.js'
import {
  Adapter
} from '@/models/Adapter.js'
import {
  router
} from 'eco-cli'

export default {
  data() {
    return {
      project: Adapter.blank(),
      status: false,
      projectInfo: Adapter.blank(),
      cloudSource: {
        serviceIp: '云主机 IP :',
        port: '数据库服务端口: ',
        userName: '登录账户: ',
        password: '账户密码: ',
        admin: '数据库超级用户: ',
        dataBasePwd: '数据库密码: ',
      },
      columns: {
        applyTime: '申请时间',
        name: '项目名称',
        company: '公司',
        applier: '联系人',
        phone: '电话',
        email: '邮箱',
      },
      loading: true, // 加载...
      rules: {
        rateContent: [
          {
            max: 1000,
            message: "输入内容字符已达上限1000个字符",
            trigger: ["blur", "change"],
          },
        ]
      }
    }
  },
  mounted() {
    this.loadSumProject()
  },
  methods: {
    loadSumProject() {
      getProjectOfCurrentUser().then((res) => {
        this.project = res
        // console.log('this.project: ', this.project)
        this.status = true
      }).finally(() => {
        this.loading = false;
      })
    },
    toApply() {
      router.open.compatibility('/apply')
    },
    handleRate(v) {
      this.$refs[v.projectId][0].validate((valid) => {
        if (valid) {
          addRate({
            id: v.projectId,
            rate: v.rate,
            rateContent: v.rateContent ? v.rateContent : '暂无'
          }).then(() => {
            this.$message.success('评价成功!')
            this.loadSumProject()
          })
        } else {

        }
      })
    }
  },
}
</script>

<style lang="scss" scoped>
@import '../../customerStyle/customerStyle';

.comp-title {
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 20px;
  color: #222;
  font-weight: 600;
}

p {
  margin: 0;
}

.project-cloud-info {

  &.sqlark {
    border-top: 1px solid #E8ECF1;
    margin-top: -56px;
    display: flex;
    flex-direction: column;
    padding-left: 24px;
    padding-right: 24px;
    margin-top: 0;;
   

    .name {
      position: relative;
    }
  }

  .sqlark-info {
    height: 100px;
    background: #FAFBFF;
    border: 1px solid #F1F4F8;
    width: 100%;
    display: flex;
    flex-direction: row;
    padding: 0 24px;
    align-items: center;

    .sqlark-logo {
      width: 52px;
      height: 52px !important;
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
      border-radius: 8px;
      flex: 0 0 auto;
      margin-right: 12px;
    }

    .content {
      flex: 1 1 0;

      .name {
        font-size: 18px;
        line-height: 20px;
        font-weight: 600;
        color: rgba(34, 34, 34, 1);
      }

      .desc {
        font-size: 14px;
        font-weight: 400;
        color: #777777;
        line-height: 22px;
      }

    }

    .download-btn {
      display: block;
      width: 108px;
      height: 32px;
      background: #4771F8;
      text-align: center;
      line-height: 32px;
      color: #fff;
    }
  }

  @include flex-row();
  justify-content: space-between;
  padding: 20px 0 36px;
  color: $theme-gray;

  .list1 {
    width: 100%;

    .name {
      @include font16();
    }

    .feed-info {

      // @include flex-row();
      // justify-content: space-between;
      // align-items: center;
      .item-wrapper {
        display: flex;
        margin-bottom: 12px;
        // border-bottom: 1px dotted rgba(0, 0, 0, 0.1);
        justify-content: space-between;
        align-items: center;
      }

      .item {
        @include font14();
        color: $theme-gray;

        .row {
          min-width: 240px;
          margin-bottom: 18px;

          .title {
            display: inline-block;
            font-size: 14px;
            font-weight: 400;
            color: #777777;
            line-height: 22px;
            width: 72px;
          }
        }

        &:first-child,
        &:last-child {
          .title {
            width: 112px;
          }
        }
      }

      .line {
        width: 1px;
        height: 36px;
        background: $color-divider-2;
      }
    }

    .desc {
      @include font14();
      color: $theme-gray;
    }
  }
}

$color-blue: #162686;
$color-yellor: #eca446;

.cloudAdapter {
  position: relative;
  height: 100%;
  background: #fff;

  .project-header {
    @include font14();
    color: $theme-gray;
    height: 22px;

    .name {
      @include font16();
      font-weight: 500;
      margin-right: 50px;
      max-width: 300px;
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      line-height: 22px;
    }

    .status {
      vertical-align: super;

      &::v-deep .ant-badge-status-dot {
        width: 10px;
        height: 10px;
      }
    }

    .time {
      margin-left: 22px;
      vertical-align: super;

      .use-days {
        color: $color-blue;
      }
    }
  }

  .project-content {
    position: relative;

    .database-type {
      padding-bottom: 24px;
      border-bottom: 1px solid $color-divider-2;

      .case-contain {
        @include flex-row();
        align-items: center;
      }

      .rect {
        @include flex-row();
        @include font24();
        align-items: center;
        color: $theme-gray;

        .database {
          @include font24();
          display: block;
        }
      }
    }

    .project-database-info {
      padding: 20px 0 20px;
      border-bottom: 1px solid $color-divider-2;

      .list {
        @include flex-row();
        justify-content: space-between;

        .item {
          @include flex-col();
          margin-right: 30px;

          .title {
            @include font14();
            color: $theme-gray-light;
            font-size: 14px;
            font-weight: 400;
            color: #777777;
            line-height: 22px;

          }

          .desc {
            @include font18();
            font-weight: 500;
            color: $theme-gray;

            font-size: 16px;
            font-weight: 500;
            color: #222222;
            line-height: 22px;
          }
        }
      }
    }

    .project-cloud-info {

      &.sqlark {
        border-top: 1px solid #E8ECF1;
        margin-top: -56px;
        display: flex;
        flex-direction: column;
      }

      .sqlark-info {
        height: 100px;
        background: #FAFBFF;
        border: 1px solid #F1F4F8;
        width: 100%;
        display: flex;
        flex-direction: row;
        padding: 0 24px;
        align-items: center;

        .sqlark-logo {
          width: 52px;
          height: 52px !important;
          box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
          border-radius: 8px;
          flex: 0 0 auto;
          margin-right: 12px;
        }

        .content {
          flex: 1 1 0;

          .name {
            font-size: 18px;
            line-height: 20px;
            font-weight: 600;
            color: rgba(34, 34, 34, 1);
          }

          .desc {
            font-size: 14px;
            font-weight: 400;
            color: #777777;
            line-height: 22px;
          }

        }

        .download-btn {
          display: block;
          width: 108px;
          height: 32px;
          background: #4771F8;
          text-align: center;
          line-height: 32px;
          color: #fff;
        }
      }

      @include flex-row();
      justify-content: space-between;
      padding: 20px 0 36px;
      color: $theme-gray;

      .list1 {
        width: 100%;

        .name {
          @include font16();
        }

        .feed-info {

          // @include flex-row();
          // justify-content: space-between;
          // align-items: center;
          .item-wrapper {
            display: flex;
            margin-bottom: 12px;
            // border-bottom: 1px dotted rgba(0, 0, 0, 0.1);
            justify-content: space-between;
            align-items: center;
          }

          .item {
            @include font14();
            color: $theme-gray;

            .row {
              min-width: 240px;
              margin-bottom: 18px;

              .title {
                display: inline-block;
                font-size: 14px;
                font-weight: 400;
                color: #777777;
                line-height: 22px;
                width: 72px;
              }
            }

            &:first-child,
            &:last-child {
              .title {
                width: 112px;
              }
            }
          }

          .line {
            width: 1px;
            height: 36px;
            background: $color-divider-2;
          }
        }

        .desc {
          @include font14();
          color: $theme-gray;
        }
      }
    }

    .project-appraise {
      padding: 10px 0 10px;
      border-top: 1px solid $color-divider-2;

      .service {
        @include flex-row();
        margin-bottom: 8px;

        .title {
          width: 57px;
          line-height: 34px;
          margin-right: 34px
        }

      }

      .rate-content {
        @include flex-row();
        padding: 10px 0px;
        font-weight: 400;

        .title {
          margin-bottom: 12px;
          margin-right: 13px;
          width: 80px;
          flex-wrap: nowrap;
        }

        .form-item {
          width: 819px;
        }

        .content {
          flex: 1;
          flex-wrap: wrap;
          word-break: break-all;
        }
      }

      .btn {
        padding: 5px 92px 0px;
        margin-top: -15px;
      }
    }
  }

  .list2 {
    position: absolute;
    right: 33px;
    top: 190px;

    img {
      width: 80px;
      height: 80px;
    }

    .serve {
      @include font14();
      width: 126px;
      margin-top: 2px;
    }
  }

  .case-efficiency,
  .case-auth {
    // padding: 16px 0;
    color: $theme-gray;
    padding-bottom: 60px;

    .title {
      @include font16();
      margin-bottom: 14px;
    }

    .desc {
      @include font14();
    }
  }

  .popover-layout ::v-deep .ant-popover-arrow {
    display: none;
  }

  .cloud-intro {
    background-color: #fff;
    padding: 32px 24px 135px 32px;

    .welcome-title {
      @include font24();
      color: $theme-gray;
      margin-bottom: 8px;
      font-weight: 600;
      line-height: 44px;
    }

    .welconme-desc {
      .item1 {
        @include font14();
        color: $theme-gray-light;
        @include content-text();
      }

      .item2 {
        @include font16();
        color: $theme-gray;
      }
    }

    .btns {
      margin-top: 38px;
      width: 159px;
      height: 36px;
      line-height: 36px;
    }
  }
}

.apply-info {
  @include font14();
  color: $theme-gray;
  text-shadow: 0px 20px 40px rgba(34, 34, 34, 0.1);
  margin-bottom: 20px;

  .title {
    font-weight: 500;
    margin-right: 18px;
    width: 56px !important;
    display: inline-block;
  }

  .desc {
    font-weight: 400;
    max-width: 500px;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: bottom;
  }
}

.steps {
  display: flex;
  flex-direction: row;

  .step {
    width: 243px;
    height: 180px;
    flex: 0 0 auto;
    border: 1px solid rgba(241, 244, 248, 1)
  }

  .header {
    border-bottom: 1px solid rgba(241, 244, 248, 1);
    height: 42px;
    background: #FAFBFF;
    font-weight: 600;
    line-height: 42px;
    padding-left: 16px;
    color: rgba(0, 0, 0, 0.95);
    font-size: 16px;
  }

  .body {
    padding: 12px 16px;
    font-size: 14px;
    font-weight: 400;
    color: #777777;
    line-height: 22px;

    a {
      color: rgba(71, 113, 248, 1);
    }
  }

  .next {
    flex: 1 1 0;
    display: flex;
    justify-content: center;
    align-items: center;

    * {
      color: rgba(71, 113, 248, 1) !important;
    }
  }
}
</style>

<style scoped>
.popover-layout>>>.ant-popover-placement-bottomRight>.ant-popover-content>.ant-popover-arrow {
  display: none !important;
}
</style>
